<div class="db-website-install__footer"
     [ngClass]="{'flex-end': userSubscription?.boosterProClient || userSubscription?.isDedicatedVM || userSubscription?.apiResellerPro}">
  @if (!userSubscription?.boosterProClient && !userSubscription?.isDedicatedVM && !userSubscription?.apiResellerPro) {
    <div class="db-website-install__footer-sites-count">
      <p>{{ 'text_hostedSites' | dbText }}</p>
      <b>{{ hostedWebsitesCount }} {{ 'text_of' | dbText }} {{ hostedWebsitesLimit }}</b>
    </div>
  }
  <div class="db-website-install__btn-wrap"
       [ngClass]="{'flex-end': userSubscription?.boosterProClient || userSubscription?.isDedicatedVM}">
    <button class="ds-btn-blue" [disabled]="loading" (click)="submitted.emit()">
      <span *ngIf="!loading">{{ isClone ? ('text_cloneBtn' | dbText) : ('text_create' | dbText) }}</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
  </div>
</div>
